import React, { useState } from "react";
import Select from "react-select";
import { Formik } from "formik";
import { Button, Form } from "react-bootstrap";

import { Common, SUCCESS, TeacherRoles, VALIDATION } from "../../../helper";
import * as commonApi from "../../../api/commonApi";
import { styles } from "../"
import { success } from "../../Shared";
import { isEmptyObject } from "../../../util";

import "../../../assets/stlyes/Modals.css";


const AssignRole = (props) => {
  const { isUserId, setAssignRole, getData } = props;
  const [isRole, setIsRole] = useState();
  const [role, setRole] = useState("");
  const [errMessage, setErrMessage] = useState(false);

  const AssignRoles = async (assignRoleData) => {
    const role=await commonApi.assignRole(assignRoleData);
    if (!isEmptyObject(role)) {
      success(`${SUCCESS.ROLE_ASSIGNED} ${role.Items.firstName} ${role.Items.lastName}`)
      getData();
    }
  }

  const getSelectedValue = (event) => {
    setIsRole(event.value);
  };
  return (
    <Formik
      initialValues={{
        role: "",
      }}
      validate={() => {
        const errors = {};
        return errors;
      }}
      onSubmit={() => {
        if (role === undefined || role === "" || role === null) {
          setErrMessage(true)
        }
        else {
          const assignRoleData = {
            id: isUserId,
            type: isRole,
          };
          AssignRoles(assignRoleData);
        }
      }}
    >
      {({
        handleSubmit
      }) => (
        <Form onSubmit={handleSubmit} style={styles.modal_form}>
          <Form.Group>
            <label htmlFor="Class">{Common.Role} </label>
            <Select
              onChange={(e) => {
                getSelectedValue(e);
                setRole(e.value);
                setErrMessage(false);
              }}
              options={TeacherRoles}
              placeholder="please select"
            />
            {errMessage && (<small className="text-danger">{VALIDATION.PLEASE_SELECT_A_ROLE}</small>)}
          </Form.Group>
          <Form.Group style={styles.button}>
            <Button
              variant="outline-secondary"
              onClick={() => {
                setAssignRole(false);
              }}
            >
              {Common.Cancel}
            </Button>&nbsp;
            <Button
              type="submit"
              variant="success"
            >
              {Common.AddRole}
            </Button>
          </Form.Group>
        </Form>
      )}
    </Formik>
  );
}

export { AssignRole };
